export * from './domain';
export * from './testkit';
export * from './builders';
export var createEmailDashboardApi = function (baseUrl, http) {
    var url = "".concat(baseUrl, "/dashboard/ticketing");
    return {
        getTableData: function (dashboardDto) { return http.post("".concat(url), dashboardDto); },
        getDashboardOverview: function (emailDashboardOverviewDto) { return http.post("".concat(url, "/overview"), emailDashboardOverviewDto); },
    };
};
//# sourceMappingURL=index.js.map